import { useEffect, useState, memo } from "react";

import { Button } from "primereact/button";
import { Chart } from "primereact/chart";

import ChartDataLabels from 'chartjs-plugin-datalabels';

export default memo(function RevisaoGraficoSetorTotalMes({ data = [], months, setor, title = "" }) {
    const [chartData, setChartData] = useState({});
    const [col, setCol] = useState("p-col-6");
    const [type, setType] = useState("line");

    const options = {
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
                formatter: (value) => {
                    return Intl.NumberFormat("pt-BR", {
                        maximumFractionDigits: 2,
                    }).format(value);
                },
                font: {
                    size: 14,
                    weight: 'bold',
                },
                color: "#2c3e50"
            },
            title: {
                display: true,
                font: {
                    size: 18
                },
                text: title
            }
        },
    }

    useEffect(() => {
        let values = [];

        months.forEach((month, index) => {
            let filteredData = data.filter((element) => {
                return parseInt(element.mes) === index + 1 && element.cod_defeitotipo === setor;
            });

            let total = 0;
            filteredData.forEach((item) => {
                total += parseFloat(item.soma);
            });

            values.push(total);
        });

        if(title !== "")
            setCol("p-col-12")

        const _chartData = {
            labels: months,
            datasets: [{
                label: "Total Mês",
                data: values,
                backgroundColor: "#2ecc71",
                borderColor: "#2ecc71"
            }]
        }

        setChartData(_chartData);
    }, [data, months, setor, title]);

    return (
        <div className={col}>
            <div className="p-d-flex p-flex-row p-jc-start">
                <Button 
                    className="p-m-1"
                    icon="pi pi-search"
                    onClick={() => {
                        setCol(col === "p-col-6" ? "p-col-12" : "p-col-6")
                    }}
                />
                <Button 
                    className="p-m-1"
                    icon={type === "line" ? "pi pi-chart-line" : "pi pi-chart-bar"}
                    onClick={() => {
                        setType(type === "line" ? "bar" : "line")
                    }}
                />
            </div>
            <Chart
                data={chartData}
                height="350px"
                width="100%"
                options={options}
                plugins={[ChartDataLabels]}
                type={type}
            />
        </div>
    )
});